import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { SideBarItems } from '@app/core/types/sidebarItems';
import { NavService } from '@reflecxshared/services/nav/nav.service';
import { environment } from '@env/environment';
import { NgxPermissionsObject, NgxPermissionsService } from 'ngx-permissions';
import { AppConfigurationService } from '@app/shared/services/app.configuration.service';
import { Identifiers } from '@app/shared/services/app.config.type';
import { Permission } from '@clearviewshared/constant/permission';
import { HeaderItems } from '@app/core/types/headerItems';
import { TranslateService } from '@ngx-translate/core';
import { GlobalFilterService } from '@app/shared/module/global-filters/global-filters.service';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FiltersService } from '@app/shared/services/filters.service';
import { tap, map, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { HelperService } from '@clearviewshared/services/helper.service';
import { AuthenticationService, Logger } from '@app/core';
import { NationalRankingService } from 'projects/cvreporting/src/app/features/cvreporting/reporting/nationak-ranking/nationa-ranking-service';
import { PresidentReportExtractService } from 'projects/cvreporting/src/app/features/cvreporting/reporting/president-report-extract/president-report-extract.service';

const log = new Logger('App');
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  sidebarItems: SideBarItems[];
  isLocked = false;
  isOpen = false;
  isSidebar = false;
  isCustomizeDashboard: boolean = true;
  public closeSideBar: EventEmitter<void> = new EventEmitter<void>();
  public sideBarTabs: Subject<SideBarItems[]> = new Subject<SideBarItems[]>();
  activeType = new BehaviorSubject<string>(null);
  permissions: NgxPermissionsObject;
  headerlist: any;
  activeItem = 'Global Dashboard';
  sideBarItems: Array<any> = [];
  isSideBarChild: boolean = false;
  sideBarChild: Array<any> = [];

  isSideBarSubChild: boolean = false;
  sideBarSubChild: Array<any> = [];
  isSideBarNotfixedClass: boolean = false;
  private globalFitlerTab: string = '';
  constructor(
    private navService: NavService,
    public ngxPermission: NgxPermissionsService,
    private appConfig: AppConfigurationService,
    public translateService: TranslateService,
    public gbfService: GlobalFilterService,
    private httpClient: HttpClient,
    private filtersService: FiltersService,
    private authService: AuthenticationService,
    private helperService: HelperService,
    private nationalRankingService: NationalRankingService,
    private presidentService: PresidentReportExtractService
  ) {
    this.permissions = ngxPermission.getPermissions();
    this.headerlist = this.appConfig.getByIdentifier(Identifiers.HeaderListOrder);
    this.gbfService.gbfTabChange.subscribe((t: any) => {
      const currentTab = JSON.parse(localStorage.getItem('gbf_tab'));
      this.globalFitlerTab = currentTab.value;
      this.tabChangeSideMenu();
    });
  }

  public getSidebarItems(): Observable<SideBarItems[]> {
    return this.sideBarTabs.asObservable();
  }

  public setSidebarItems(tabs: SideBarItems[]): void {
    this.sidebarItems = tabs;
    this.sideBarTabs.next(tabs);
  }

  public getItems() {
    return this.sidebarItems;
  }

  public lockSideBar() {
    this.isLocked = true;
  }

  public unLockSideBar() {
    this.isLocked = false;
  }

  public isSideBarLocked() {
    return this.isLocked;
  }

  public setActiveItems(item: string) {
    this.navService.setTitleClearView(item);
    if (this.sidebarItems) {
      this.sidebarItems.map((x, index, arr) => {
        arr[index].active = false;
        arr[index].showChild = false;
        if (item === x.name) {
          arr[index].active = true;
        }
        if (x.children && x.children.length > 0 && x.children.findIndex((y) => y.name === item) > 0) {
          arr[index].active = true;
          arr[index].showChild = true;
        }
      });
    }
  }

  public reset() {
    if (this.sidebarItems) {
      this.sidebarItems.map((x, index, arr) => {
        arr[index].active = false;
        arr[index].showChild = false;
      });
    }
  }

  public setItems(module: string, activeModule: string) {
    const authData: any = this.authService.getUser();
    this.activeItem = activeModule;
    const currentTab = JSON.parse(localStorage.getItem('gbf_tab'));
    this.globalFitlerTab = currentTab.value;
    switch (module) {
      case environment.reportingRoutePrefix:
        this.sideBarItems = this.createReportingHeader(activeModule);
        this.tabChangeSideMenu();
        break;
      case environment.reflecxRoutePrefix:
        this.sideBarItems = this.createAdminHeader(activeModule);
        break;
    }
  }

  private createReportingHeader(activeModule: string) {
    const headers: HeaderItems[] = [];
    if (this.headerlist) {
      if (this.headerlist.ClientConfig === null) {
        this.headerlist.ClientConfig = this.headerlist;
      }
      if (this.headerlist.ClientConfig) {
        this.headerlist.ClientConfig.Fields.Dashboard.forEach((header: any) => {
          if (header === 'Global Dashboard' && this.permissions[Permission.MENU_GLOBAL_DASHBOARD] ? true : false) {
            headers.push({
              active: activeModule === 'Global Dashboard',
              //active: false,
              icon: 'fal fa-tachometer-alt',
              html: 'Dashboard',
              name: 'Dashboard',
              anchorId: 'app.globaldashboard',
              module: 'dashboard',
              url: `/${environment.reportingRoutePrefix}/dashboard`,
              children: this.createGlobalDashboard(),
            });
          } else if (header === 'Hot Alerts' && this.permissions[Permission.MENU_HOTALERT] ? true : false) {
            headers.push({
              active: activeModule === 'Hot Alerts',
              //active: false,
              icon: 'fal fa-exclamation-circle',
              html: 'Alerts',
              name: 'Alerts',
              anchorId: 'app.hotalert',
              module: 'alerts',
              url: `/${environment.reportingRoutePrefix}/alerts`,
              children: this.createAlert(),
            });
          } else if (header === 'Reporting' && this.permissions[Permission.MENU_REPORTS_SECTION] ? true : false) {
            headers.push({
              active: activeModule === 'Reporting',
              //active: false,
              icon: 'fal fa-list-alt',
              html: 'Reports',
              name: 'Reports',
              anchorId: 'app.reporting',
              module: 'reports',
              url: `/${environment.reportingRoutePrefix}/reports`,
              children: this.createReport(),
            });
          } else if (
            header === 'Report Generator' && this.permissions[Permission.MENU_REPORT_GENERATOR] ? true : false
          ) {
            headers.push({
              active: activeModule === 'Report Generator',
              //active: false,
              icon: 'fal fa-sliders-v',
              html: 'Report <br/> Generator',
              name: 'Report Generator',
              anchorId: 'app.reportgenerator',
              module: 'rg',
              url: `/${environment.reportingRoutePrefix}/rg`,
              children: this.createReportGenerator(),
            });
          } else if (header === 'Epanel' && this.permissions[Permission.MENU_EPANEL] ? true : false) {
            headers.push({
              active: activeModule === 'Epanel',
              icon: 'fal fa-wrench',
              html: 'Epanel',
              anchorId: 'app.epanel',
              name: 'Epanel',
              module: 'epanel',
              url: '/epanel-sso',
              children: [],
            });
          } else if (header === 'Cross Tabs' && this.permissions[Permission.MENU_CROSSTAB] ? true : false) {
            headers.push({
              active: activeModule === 'Cross Tabs',
              //active: false,
              icon: 'fal fa-book',
              html: 'Cross <br/> Tabs',
              anchorId: 'app.crosstab',
              name: 'Cross Tabs',
              module: 'ct',
              url: `/${environment.reportingRoutePrefix}/ct`,
              children: [],
            });
          } else if (header === 'Bulletin' && this.permissions[Permission.MENU_BULLETIN] ? true : false) {
            headers.push({
              active: activeModule === 'Bulletin',
              //active: false,
              icon: 'fa-light fa-newspaper',
              html: 'Bulletin',
              anchorId: 'app.bulletin',
              name: 'Bulletin',
              module: 'bu',
              url: `/${environment.reportingRoutePrefix}/bu`,
              children: [],
            });
          } else if (header === 'Coach' && this.permissions[Permission.REPORT_COACH] ? true : false) {
            headers.push({
              active: activeModule === 'Coach',
              //active: false,
              icon: 'fal fa-window-restore',
              html: 'Coach <br/> Tabs',
              anchorId: 'app.coach',
              name: 'Coach',
              module: 'coach',
              url: `/${environment.reportingRoutePrefix}/coach`,
              children: this.createCoach(),
            });
          } else if (header === 'Appeals' && this.permissions[Permission.MENU_APPEALS] ? true : false) {
            headers.push({
              active: activeModule === 'Appeals',
              //active: false,
              icon: 'fal fa-clipboard-list',
              html: 'Appeals',
              name: 'Appeals',
              anchorId: 'app.appeal',
              module: 'appeal',
              url: `/${environment.reportingRoutePrefix}/appeal`,
              children: this.createAppeal(),
            });
          } else if (header === 'VOC' && this.permissions[Permission.REPORT_TEXTANALYTIC_VOCDASHBOARD] ? true : false) {
            headers.push({
              active: activeModule === 'VOC',
              //active: false,
              icon: 'fal fa-chart-line',
              html: 'Text Analytics',
              anchorId: 'app.voc',
              name: 'Text Analytics',
              module: 'voc',
              url: `/${environment.reportingRoutePrefix}/voc`,
              children: this.createTextAnalytics(),
            });
          } else if (header === 'Social Media' && this.permissions[Permission.MENU_SOCIALMEDIA] ? true : false) {
            headers.push({
              active: activeModule === 'Social Media',
              //active: false,
              icon: 'fal fa-users',
              html: 'Reputation <br/> Management',
              name: 'Reputation Management',
              anchorId: 'app.socialmedia',
              module: 'rm',
              url: `/${environment.reportingRoutePrefix}/rm`,
              children: this.createReputationManagement(),
            });
          } else if (header === 'VOC Demo' && this.permissions[Permission.MENU_VOCDEMO] ? true : false) {
            headers.push({
              active: activeModule === 'VOC Demo',
              //active: false,
              icon: 'fal fa-chart-line',
              html: 'VOC <br/> Demo',
              name: 'VOC Demo',
              anchorId: 'app.vocdemo',
              module: 'vocdemo',
              url: `/${environment.reportingRoutePrefix}/vocdemo`,
              children: [],
            });
          } else if (header === 'Alias Module' && this.permissions[Permission.REPORT_ALIAS_REPORT] ? true : false) {
            headers.push({
              active: activeModule === 'Alias Module',
              //active: false,
              icon: 'fal fa-street-view',
              html: 'Alias <br/> Management',
              name: 'Alias Management',
              anchorId: 'app.aliasmodule',
              module: 'aliasmodule',
              url: `/${environment.reportingRoutePrefix}/aliasmodule`,
              children: [],
            });
          } else if (header === 'Target Module' && this.permissions[Permission.TARGET_UPDATE_MODULE] ? true : false) {
            headers.push({
              active: activeModule === 'Target Setup',
              //active: false,
              icon: 'fal fa-bullseye-arrow',
              html: 'Target <br/> Setup',
              name: 'Target Setup',
              anchorId: 'app.targetmodule',
              module: 'targetmodule',
              url: `/${environment.reportingRoutePrefix}/targetmodule`,
              children: [],
            });
          }
        });

        let activeItems = headers.find((r) => r.active === true);
        if (activeItems === null || activeItems === undefined) {
          headers[0].active = true;
        }
      }
    }
    return headers;
  }

  public launchEpanelSSO(): void {
    const user = this.authService.getUser();
    if (!user) {
      console.error('No logged-in user context found.');
      return;
    }

    console.log(user);
    const payload = {
      userName: user.UserName,
      firstName: user.FirstName,
      lastName: user.LastName,
      email: user.Email,
      roleName: user.Role,
      clientName: 'epanel',
      defaultLanguage: user.DefaultLanguage,
    };

    this.httpClient.post<any>(`${environment.apiUrl}/api/v1/user/encrypt-user`, payload).subscribe({
      next: (res) => {
        console.log(res);
        if (res && res.IsSuccess && res.EncryptedToken) {
          // const externalGatewayUrl = `https://devcx.reflecx.io/portal/sso?ssoParam=${encodeURIComponent(res.EncryptedToken)}`;
          const externalGatewayUrl = `${environment.epanelSsoUrl}/sso?ssoParam=${encodeURIComponent(
            res.EncryptedToken
          )}`;
          window.open(externalGatewayUrl, '_blank');
        } else {
          console.error('Encryption failed:', res.message);
        }
      },
      error: (err) => console.error('SSO Generation Error:', err),
    });
  }

  private createAdminHeader(activeModule: string) {
    const headers: HeaderItems[] = [];
    if (this.headerlist) {
      if (this.headerlist.ClientConfig === null) {
        this.headerlist.ClientConfig = this.headerlist;
      }
      if (this.headerlist.ClientConfig) {
        this.headerlist.ClientConfig.Fields.Admin.forEach((header: any) => {
          if (header === 'datasource' && this.permissions[Permission.MENU_DATASOURCE] ? true : false) {
            headers.push({
              active: activeModule == 'Data Sources',
              icon: 'fal fa-list-alt',
              html: 'Data Sources',
              name: 'Data Sources',
              anchorId: 'app.datasource',
              module: 'datasource',
              url: `/${environment.reflecxRoutePrefix}/datasource`,
              children: this.createSideBarDataSource(),
            });
          } else if (header === 'survey' && this.permissions[Permission.MENU_SURVEY] ? true : false) {
            headers.push({
              active: activeModule == 'Surveys',
              icon: 'fa-light fa-clipboard-list-check',
              html: 'Surveys',
              name: 'Surveys',
              anchorId: 'app.survey',
              module: 'survey',
              url: `/${environment.reflecxRoutePrefix}/survey`,
              children: this.createSideBarSurvey(),
            });
          } else if (header === 'transmission' && this.permissions[Permission.MENU_TRANSMISSION] ? true : false) {
            headers.push({
              active: activeModule == 'Transmissions',
              icon: 'fal fa-retweet',
              html: 'Transmissions',
              name: 'Transmissions',
              anchorId: 'app.transmission',
              module: 'tranmission',
              url: `/${environment.reflecxRoutePrefix}/transmission`,
              children: [],
            });
          } else if (header === 'insights' && this.permissions[Permission.MENU_INSIGHT] ? true : false) {
            headers.push({
              active: activeModule == 'Insights',
              icon: 'fal fa-chart-bar',
              html: 'Insights',
              name: 'Insights',
              anchorId: 'app.insight',
              module: 'insight',
              url: `/${environment.reflecxRoutePrefix}/insight`,
              children: this.createSideBarInsight(),
            });
          } else if (header === 'LibraryModule' && this.permissions[Permission.MENU_LIBRARY] ? true : false) {
            headers.push({
              active: activeModule == 'Library',
              icon: 'fal fa-copy',
              html: 'Library',
              name: 'Library',
              anchorId: 'app.library',
              module: 'library',
              url: `/${environment.reflecxRoutePrefix}/library`,
              children: [],
            });
          } else if (header === 'user' && this.permissions[Permission.MENU_USER] ? true : false) {
            headers.push({
              active: activeModule == 'Users',
              icon: 'fal fa-user-cog',
              html: 'Users',
              name: 'Users',
              anchorId: 'app.user',
              module: 'admin',
              url: `/${environment.reflecxRoutePrefix}/admin`,
              children: this.createSideBarUser(),
            });
          }
        });
      }
    }

    return headers;
  }

  private createGlobalDashboard() {
    const sidebar: SideBarItems[] = [];
    sidebar.push({
      name: this.translateService.instant('Main Dashboard'),
      active: true,
      route: `/${environment.reportingRoutePrefix}/dashboard`,
      children: [],
    });
    if (this.permissions['reporting_globaldashboard_customersearch']) {
      sidebar.push({
        name: 'Customer Search',
        active: false,
        route: `/${environment.reportingRoutePrefix}/dashboard/customersearch`,
        children: [],
      });
    }
    // if (true) {
    //   sidebar.push({
    //     name: 'Claim Dashboard',
    //     active: false,
    //     route: `/${environment.reportingRoutePrefix}/dashboard/claim`,
    //     children: [],
    //   });
    // }
    // if (true) {
    //   sidebar.push({
    //     name: 'F&I Specialist Dashboard',
    //     active: false,
    //     route: `/${environment.reportingRoutePrefix}/dashboard/fAndI`,
    //   });
    // }
    // if (true) {
    //   sidebar.push({
    //     name: 'Dealer Engagement Dashboard',
    //     active: false,
    //     route: `/${environment.reportingRoutePrefix}/dashboard/dealerengagement`,
    //   });
    // }
    if (this.permissions[Permission.GLOBALDASHBOARD_SURVEYLIST]) {
      sidebar.push({
        name: 'Survey List',
        active: false,
        route: `/${environment.reportingRoutePrefix}/dashboard/surveylist`,
        children: [],
      });
    }
    if (this.permissions[Permission.GLOBALDASHBOARD_SURVEYLIST_DELETED]) {
      const status = 'deleted';
      sidebar.push({
        name: 'Survey List – Deleted Surveys',
        active: false,
        route: `/${environment.reportingRoutePrefix}/dashboard/surveylist/${status}`,
        children: [],
      });
    }
    if (this.permissions['reporting_globaldashboard_surveyresend']) {
      sidebar.push({
        name: 'Survey Resend',
        active: false,
        route: `/${environment.reportingRoutePrefix}/dashboard/surveyresend`,
        children: [],
      });
    }
    return sidebar;
  }

  private createAppeal() {
    const sidebar: SideBarItems[] = [];
    if (this.permissions['reporting_appeals_appealsearch']) {
      sidebar.push({
        name: this.translateService.instant('appeal_search.title'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/appeal/search`,
        children: [],
      });
    }
    if (this.permissions['reporting_appeals_myappeals']) {
      sidebar.push({
        name: this.translateService.instant('my_appeals.title'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/appeal/myappeal`,
        children: [],
      });
    }
    return sidebar;
  }

  private createAlert() {
    const tabs: SideBarItems[] = [];
    if (this.permissions[Permission.MENU_HOTALERT]) {
      tabs.push({
        name: 'Alert Dashboard',
        active: false,
        route: '/insights/alerts/summary',
      });
    }
    if (this.permissions[Permission.REPORT_HOTALERT_LIST]) {
      tabs.push({
        name: 'Alert List',
        active: false,
        route: '/insights/alerts/list',
      });
    }
    return tabs;
  }

  private createReport() {
    const sidebar: SideBarItems[] = [];
    if (this.permissions[Permission.REPORT_CONSTACTSTATS]) {
      sidebar.push({
        name: this.translateService.instant('Contact Statistics'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/statistics`,
      });
    }

    if (this.permissions[Permission.REPORT_Sample_Disposition]) {
      sidebar.push({
        name: this.translateService.instant('Sample Disposition'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/sampledisposition`,
      });
    }

    if (this.permissions[Permission.REPORT_ORGANIZATION_SUMMARY]) {
      sidebar.push({
        name: this.translateService.instant('Organization Summary'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/orgsummary`,
      });
    }

    if (this.permissions[Permission.REPORT_DEALER_VARIABLE_BONUS]) {
      sidebar.push({
        name: this.translateService.instant('5 Star Rating'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/dealervariablebonus`,
      });
    }

    if (this.permissions[Permission.REPORT_SURVEYLIST]) {
      sidebar.push({
        name: this.translateService.instant('Survey List'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/surveylist`,
      });
    }
    if (this.permissions[Permission.REPORT_PERFORMANCE_TREND]) {
      sidebar.push({
        name: this.translateService.instant('Performance Trend'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/performancetrend/1`,
      });
    }
    if (this.permissions[Permission.REPORT_SURVEYLIST_DELETED]) {
      const status = 'deleted';
      sidebar.push({
        name: this.translateService.instant('Survey List – Deleted Surveys'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/surveylist/${status}`,
      });
    }
    if (this.permissions[Permission.REPORT_MANIPULATION_REPORT]) {
      sidebar.push({
        name: this.translateService.instant('Manipulation Report'),
        active: false,
        isAllowRouting: false,
        click: () => this.getManipulationReportExportExtract2(),
        route: `/${environment.reportingRoutePrefix}/reports/manipulationreport`,
      });
    }

    if (this.permissions[Permission.REPORT_PRESIDENTPROGRAM_REPORT]) {
      sidebar.push({
        name: this.translateService.instant('President Program Summary Report'),
        active: false,
        isAllowRouting: false,
        click: () => this.presidentService.getPresidentExtractExport('PresidentExtract'),
        route: `/${environment.reportingRoutePrefix}/reports/presidentprogramreport`,
      });
    }

    if (this.permissions[Permission.REPORT_NATIONAL_RANKING_REPORT]) {
      sidebar.push({
        name: this.translateService.instant('National Ranking Report'),
        active: false,
        isAllowRouting: false,
        click: () => this.nationalRankingService.getNationalRankingExport('nationalrankingreport'),
        route: `/${environment.reportingRoutePrefix}/reports/nationalrankingreport`,
      });
    }

    // if (this.permissions[Permission.REPORT_SERVICE_ADVISOR_REPORT]) {
    //   var result = this.configService.getReportMenu()?.tech_service_advisor;
    //   result.forEach((val: any) => {
    //     sidebar.push({
    //       name: this.translateService.instant(val.name),
    //       active: false,
    //       isAllowRouting: true,
    //       route: `/${environment.reportingRoutePrefix}/reports/scoring/${val.key}`,
    //     });
    //   });
    // }

    if (this.permissions[Permission.REPORT_PORTALTRAFFIC]) {
      sidebar.push({
        name: this.translateService.instant('Portal Traffic'),
        active: false,
        route: this.createPortalTraffic().firstChild.route,
        children: this.createPortalTraffic().children,
      });
    }
    // if (this.permissions[Permission.REPORT_PORTALTRAFFIC]) {
    //   this.createPublishedReportMenu(sidebar);
    // }
    if (this.permissions[Permission.REPORT_COMPARISON]) {
      sidebar.push({
        name: this.translateService.instant('Comparison Report'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/comparisonreport`,
      });
    }

    if (this.permissions[Permission.REPORT_DAY_OF_WEEK_REPORT]) {
      sidebar.push({
        name: this.translateService.instant('Day of Week Report'),
        active: false,
        showChild: false,
        route: `/${environment.reportingRoutePrefix}/reports/dayofweekreport`,
      });
    }
    if (this.permissions[Permission.REPORT_DAILY_REPORT]) {
      sidebar.push({
        name: this.translateService.instant('daily_report'),
        active: false,
        showChild: false,
        route: `/${environment.reportingRoutePrefix}/reports/dailyreport`,
      });
    }

    if (this.permissions[Permission.REPORT_MANAGEMENT_REPORT]) {
      sidebar.push({
        name: this.translateService.instant('Management Report'),
        active: false,
        showChild: false,
        route: `/${environment.reportingRoutePrefix}/reports/managementreport`,
      });
    }

    if (this.permissions[Permission.REPORT_EMAIL_DISPOSITION_REPORT]) {
      sidebar.push({
        name: this.translateService.instant('Email Disposition Report'),
        active: false,
        showChild: false,
        route: `/${environment.reportingRoutePrefix}/reports/emaildispositionreport`,
      });
    }
    if (this.permissions[Permission.REPORT_SERVICE_ADVISOR_REPORT]) {
      var result = this.appConfig.getReportMenu()?.tech_service_advisor;
      result.forEach((val: any) => {
        sidebar.push({
          name: this.translateService.instant(val.name),
          active: false,
          showChild: false,
          route: `/${environment.reportingRoutePrefix}/reports/scoring/${val.key}`,
        });
      });
    }
    if (this.permissions[Permission.REPORT_DEALER_SCORE_CARD]) {
      sidebar.push({
        name: this.translateService.instant('Dealer Score Card'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/dealerscorecard`,
      });
    }
    if (this.permissions[Permission.REPORT_ZONE_SCORE_CARD]) {
      sidebar.push({
        name: this.translateService.instant('Zone Score Card'),
        active: false,
        route: `/${environment.reportingRoutePrefix}/reports/zonescorecard`,
      });
    }
    return sidebar;
  }
  public createPortalTraffic(currentStatus: string = '') {
    const children: SideBarItems[] = [];
    if (this.permissions[Permission.REPORT_LOGIN_SUMMARY]) {
      children.push({
        name: 'Login Summary',
        active: currentStatus == 'loginSummary' ? true : false,
        icon: 'fa-thin fa-file-lines',
        route: `/${environment.reportingRoutePrefix}/reports/portaltraffic/loginsummary`,
      });
    }
    if (this.permissions[Permission.REPORT_PORTALTRAFFIC_LOGINDETAIL]) {
      children.push({
        name: 'Login and Traffic Stats Details',
        active: currentStatus == 'trafficStats' ? true : false,
        icon: 'fa-light fa-notebook',
        route: `/${environment.reportingRoutePrefix}/reports/portaltraffic/trafficdetails`,
      });
    }
    if (this.permissions[Permission.REPORT_PORTALTRAFFIC_LOGINSUMMARY]) {
      children.push({
        name: 'Login and Site Traffic Summary',
        active: currentStatus == 'trafficSummary' ? true : false,
        icon: 'fa-light fa-memo-pad',
        route: `/${environment.reportingRoutePrefix}/reports/portaltraffic/trafficsummary`,
      });
    }
    return { children, firstChild: children[0] };
  }

  private createTextAnalytics() {
    const tabs: SideBarItems[] = [];
    tabs.push({
      name: 'Main Dashboard',
      active: false,
      route: `/${environment.reportingRoutePrefix}/voc`,
    });
    if (this.permissions[Permission.REPORT_TEXTANALYTIC_TREEREPORT]) {
      tabs.push({
        name: 'Tree Report',
        active: false,
        route: '/insights/voc/treereport/voc',
      });
    }
    if (this.permissions[Permission.REPORT_TEXTANALYTIC_VOCDASHBOARD]) {
      tabs.push({
        name: 'Dynamic Topic Search',
        active: false,
        route: '/insights/voc/dynamictopic/voc',
      });
    }
    if (this.permissions[Permission.REPORT_TEXTANALYTIC_COMMENTLIST]) {
      tabs.push({
        name: 'Comment List',
        active: false,
        route: '/insights/voc/commentlist',
      });
    }
    if (this.permissions[Permission.REPORT_TEXTANALYTIC_CATEGORYCONFIGURATION]) {
      tabs.push({
        name: 'Category Configuration',
        active: false,
        route: '/insights/voc/categoryconfiguration',
      });
    }
    // }
    return tabs;
  }

  private createReputationManagement() {
    const tabs: SideBarItems[] = [];
    tabs.push({
      name: 'Main Dashboard',
      active: false,
      route: `/${environment.reportingRoutePrefix}/rm`,
    });

    if (this.permissions[Permission.REPORT_SOCIALMEDIA_RANKINGREPORT]) {
      tabs.push({
        name: 'ranking_report.title',
        active: false,
        route: '/insights/rm/rankingreport',
      });
    }

    if (this.permissions[Permission.REPORT_SOCIALMEDIA_REVIEWLIST]) {
      tabs.push({
        name: 'review_list_report.title',
        active: false,
        route: '/insights/rm/reviewlist',
      });
    }

    if (this.permissions[Permission.REPORT_SOCIALMEDIA_PERFORMANCETREND]) {
      tabs.push({
        name: 'performance_trend_report.title',
        active: false,
        route: '/insights/rm/performancetrend',
      });
    }

    if (this.permissions[Permission.REPORT_SOCIALMEDIA_MASTERLIST]) {
      tabs.push({
        name: 'master_list_report.title',
        active: false,
        route: '/insights/rm/masterlist',
      });
    }

    if (this.permissions[Permission.REPORT_SOCIALMEDIA_DEALERCOMPETITORS]) {
      tabs.push({
        name: 'competitors_report.title',
        active: false,
        route: '/insights/rm/dealercompetitors',
      });
    }

    if (this.permissions[Permission.REPORT_SOCIALMEDIA_TREEREPORT]) {
      tabs.push({
        name: 'Tree Report',
        active: false,
        route: '/insights/rm/treereport/sm',
      });
    }
    if (this.permissions[Permission.REPORT_SOCIALMEDIA_DYNAMICTOPICSEARCH]) {
      tabs.push({
        name: 'Dynamic Topic Search',
        active: false,
        route: '/insights/rm/dynamictopic/sm',
      });
    }
    if (this.permissions[Permission.REPORT_SOCIALMEDIA_MONTHLY_SCORECARD]) {
      tabs.push({
        active: false,
        name: 'monthly_scorecard_report.title',
        route: '/insights/rm/scorecard',
      });
    }

    return tabs;
  }

  private createReportGenerator() {
    const sidebar: SideBarItems[] = [];
    if (this.permissions[Permission.MENU_REPORT_GENERATOR]) {
      sidebar.push({
        name: 'Main Canvas',
        active: false,
        route: '/insights/rg',
      });
    }
    if (this.permissions[Permission.REPORT_REPORTGENERATOR_MYREPORT]) {
      sidebar.push({
        name: 'My Reports',
        active: false,
        route: '/insights/rg/myreport',
      });
    }
    if (this.permissions[Permission.REPORT_REPORTGENERATOR_PUBLISHREPORT]) {
      sidebar.push({
        name: 'Publish Custom Reports',
        active: false,
        route: '/insights/rg/customreports',
      });
    }
    return sidebar;
  }

  private createCoach() {
    const tabs: SideBarItems[] = [];

    if (this.permissions[Permission.REPORT_COACH_ACTIONPLAN]) {
      tabs.push({
        name: 'Coach.Action Plan',
        active: false,
        route: '/insights/coach/actionplan-list',
      });
    }
    if (this.permissions[Permission.REPORT_COACH_CONTACTREPORT]) {
      tabs.push({
        name: 'Contact Report',
        active: false,
        route: '/insights/coach/contactreport-list',
      });
    }
    return tabs;
  }

  private createSideBarDataSource() {
    const tabs: SideBarItems[] = [];
    const dataSourceMasterCustomer = this.permissions[Identifiers.DataSourceMasterCustomerList] ? true : false;
    if (true) {
      tabs.push({
        name: this.translateService.instant('Datasource List'),
        active: true,
        route: `/${environment.reflecxRoutePrefix}/datasource`,
        queryParams: {},
      });
    }
    if (dataSourceMasterCustomer) {
      tabs.push({
        name: this.translateService.instant('Master Customers'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/datasource/mastercustomer`,
        queryParams: {},
      });
    }
    return tabs;
  }

  private createSideBarSurvey() {
    const tabs: SideBarItems[] = [];
    const surveyCoreFilter = this.permissions[Identifiers.SurveyCoreFilter] ? true : false;
    const surveyAdhocFilter = this.permissions[Identifiers.SurveyAdhocFilter] ? true : false;
    const surveyFollowUpFilter = this.permissions[Identifiers.SurveyFollowUpHotAlert] ? true : false;

    if (surveyCoreFilter) {
      tabs.push({
        name: this.translateService.instant('Core'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/survey`,
        queryParams: { adCo: 2 },
      });
    }
    if (surveyAdhocFilter) {
      tabs.push({
        name: this.translateService.instant('Adhoc'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/survey`,
        queryParams: { adCo: 1 },
      });
    }
    if (surveyFollowUpFilter) {
      tabs.push({
        name: this.translateService.instant('FollowUp'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/survey`,
        queryParams: { adCo: 3 },
      });
    }
    return tabs;
  }

  private createSideBarInsight() {
    const tabs: SideBarItems[] = [];

    if (this.permissions[Identifiers.InsightDashboard] ? true : false) {
      tabs.push({
        name: this.translateService.instant('Dashboard'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/insight`,
        queryParams: {},
      });
    }
    if (this.permissions[Identifiers.InsightReport] ? true : false) {
      tabs.push({
        name: this.translateService.instant('Reports'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/insight/reporting`,
        queryParams: {},
      });
    }
    if (this.permissions[Identifiers.InsightAdhoc] ? true : false) {
      tabs.push({
        name: this.translateService.instant('Adhoc Reports'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/insight/adhocReporting`,
        queryParams: {},
      });
    }
    if (this.permissions[Identifiers.InsightPivotGridReport] ? true : false) {
      tabs.push({
        name: this.translateService.instant('Pivot Grid Report'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/insight/pivotgridReport`,
        queryParams: {},
      });
    }
    if (this.permissions[Identifiers.InsightDownload] ? true : false) {
      tabs.push({
        name: this.translateService.instant('Download Reports'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/insight/downloadableReport`,
        queryParams: {},
      });
    }
    return tabs;
  }

  private createSideBarUser() {
    const tabs: SideBarItems[] = [];

    if (this.permissions[Identifiers.ReadUser] ? true : false) {
      tabs.push({
        name: this.translateService.instant('User List'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/admin/user`,
        queryParams: {},
      });
    }
    if (this.permissions[Identifiers.ReadRole] ? true : false) {
      tabs.push({
        name: this.translateService.instant('Roles'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/admin/role`,
        queryParams: {},
      });
    }
    if (this.permissions[Identifiers.ReadClient] ? true : false) {
      tabs.push({
        name: this.translateService.instant('Clients'),
        active: false,
        route: `/${environment.reflecxRoutePrefix}/admin/client`,
        queryParams: {},
      });
    }
    return tabs;
  }

  public onSideBarChildItem(item: any) {
    this.sideBarChild.forEach((side: any) => {
      side.active = false;
    });
    item.active = true;
  }

  private tabChangeSideMenu() {
    // if (this.permissions[Permission.REPORT_FRFT_REPORT]) {
    this.sideBarItems.forEach((sidebar: any) => {
      if (sidebar.module == 'reports') {
        const findIndex = sidebar.children.findIndex((child: any) => child.id == 'frft');
        if (findIndex == -1 && this.globalFitlerTab == 'Service' && this.permissions[Permission.REPORT_FRFT_REPORT]) {
          sidebar.children.push({
            name: this.translateService.instant('FRFT Dashboard'),
            active: false,
            showChild: false,
            route: `/${environment.reportingRoutePrefix}/reports/frftreports`,
            id: 'frft',
          });
        } else if (findIndex !== -1 && this.globalFitlerTab == 'Sale') {
          sidebar.children.pop();
        }
      }
    });
    // }
  }

  public resetOrg(): void {
    const reverseDefaultSelection = JSON.parse(localStorage.getItem('gbf_org_param'));
    if (reverseDefaultSelection && reverseDefaultSelection.selected) {
      localStorage.setItem('gbf_org', JSON.stringify(reverseDefaultSelection));
    }
  }

  private getManipulationReportExportExtract2(
    sort: { field: string; order: number } = { field: 'created_on', order: -1 }
  ) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const filters = this.filtersService.getFilterObject();
    filters.PageNo = 1;
    filters.PageSize = 1000000;
    filters.Sort = sort.order.toString();
    filters.SortColumn = sort.field;

    const authData: any = this.authService.getUser();
    let Accept_Language;
    if (authData) {
      Accept_Language = localStorage.getItem('language');
      if (!Accept_Language) {
        Accept_Language = 'en-ca';
      }
    }

    const url = `/reporting/GetManipulationReportExportExtract/true/${Accept_Language}`;

    this.httpClient
      .post(url, filters, { responseType: 'arraybuffer', observe: 'response', headers: headers })
      .pipe(
        catchError((err) => {
          return EMPTY;
        })
      )
      .subscribe((res) => {
        const filename = this.translateService.instant('Manipulation Report');
        var headers = res.headers.get('content-disposition');

        if (headers.lastIndexOf('csv') != -1) {
          this.helperService.exportCSVFile(res, filename);
        } else if (headers.lastIndexOf('xlsx')) {
          this.helperService.exportExelFile(res, filename);
        }
      });
  }
}
